import React, { useState } from 'react';
import './projects.css';
import { SiNextdotjs, SiUnity } from 'react-icons/si';
import { BsDiscord, BsLaptop } from 'react-icons/bs';
import { SiMyanimelist } from 'react-icons/si';
import { AiOutlineRobot } from 'react-icons/ai';
import { FaGithub } from 'react-icons/fa';

const Projects = () => {
  return (
    <section id='projects'>
      <h5> Estos son mis</h5>
      <h2> Últimos Proyectos</h2>

      <div className='container'>
        <div className='about__content'>
          <div className='project__cards'>
            <article className='project__card'>
              <SiMyanimelist className='project__icon' />

              <h5> Animelist</h5>
              <a
                href='https://github.com/Adan-Perez?tab=repositories'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={require('../../assets/img-projects/animelist_project.png')}
                  alt='Animelist Project'
                  className='project__img'
                />
              </a>
              <small>
                Aplicación de escritorio. Uso de API externa y base de datos SQLite
              </small>
            </article>

            <article className='project__card'>
              <AiOutlineRobot className='project__icon' />
              <h5> Cyberpunk Website</h5>

              <a
                href='https://adanperez-cyberpunk-website-react.netlify.app/'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={require('../../assets/img-projects/cyberpunk_project.jpg')}
                  alt='Gym Project'
                  className='project__img'
                />
              </a>

              <small>Sitio Web. Desarrollado en React y Tailwindcss</small>
            </article>

            <article className='project__card'>
              <SiUnity className='project__icon' />
              <h5> Search of Souls</h5>
              <a
                href='https://github.com/Adan-Perez?tab=repositories'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={require('../../assets/img-projects/Unity.png')}
                  alt='Unity Project'
                  className='project__img'
                />
              </a>
              <small>Videojuego 2D. Desarrollado en Unity y C#</small>
            </article>

            <article className='project__card'>
              <BsLaptop className='project__icon' />
              <h5> Tech Website</h5>
              <a
                href='https://adanperez-tech-website-nextjs.netlify.app/'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={require('../../assets/img-projects/standard_website_nextjs.png')}
                  alt='Standard Website Project'
                  className='project__img'
                />
              </a>
              <small>Sitio Web. Desarrollada en Next.js y Tailwindcss</small>
            </article>

            <article className='project__card'>
              <BsDiscord className='project__icon' />
              <h5> Discord Portfolio</h5>
              <a
                href='https://adanperez-discord-portfolio.netlify.app/'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={require('../../assets/img-projects/discord_project.jpg')}
                  alt='Gym Project'
                  className='project__img'
                />
              </a>
              <small>Aplicación Web. Desarrollada en Vue.js</small>
            </article>

            <article className='project__card'>
              <SiNextdotjs className='project__icon' />
              <h5> Cosmetic Ecommerce</h5>{' '}
              <a
                href='https://github.com/Adan-Perez?tab=repositories'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={require('../../assets/img-projects/cosmetic_nextjs.png')}
                  alt='Cosmetic Web Project'
                  className='project__img'
                />
              </a>
              <small>
                Aplicación Web inspirada en Sephora. Desarrollada en Next.js y
                Tailwindcss
              </small>
            </article>
          </div>

          <div className='about__info'>
            <h4>
              Para más información sobre mis proyectos, visite mi perfil de
              <a
                href='https://github.com/Adan-Perez?tab=repositories'
                className='cv-download'>
                {' '}
                Github{' '}
              </a>
              <FaGithub className='github__icon' />
            </h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
